import { z } from "zod";

/**
 * RFC 5322 compliant email validation.
 * Ensures effective, deliverable-looking addresses.
 */
export const effectiveEmailSchema = z
  .string()
  .min(1, "Email is required")
  .email("Please enter a valid email address")
  .max(254, "Email too long")
  .refine(
    (val) => {
      // Basic format check - local + @ + domain
      const parts = val.split("@");
      if (parts.length !== 2) return false;
      const [local, domain] = parts;
      return local.length >= 1 && domain.length >= 4 && domain.includes(".");
    },
    { message: "Please enter a valid email address" }
  );

export type EffectiveEmail = z.infer<typeof effectiveEmailSchema>;
